import { render } from "./StafetDeltagSomFighterFlow.vue?vue&type=template&id=6580c69b"
import script from "./StafetDeltagSomFighterFlow.vue?vue&type=script&lang=js"
export * from "./StafetDeltagSomFighterFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__